var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrors(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.418 21.06c.612 0 1.104.497 1.104 1.108 0 .614-.492 1.109-1.104 1.109a1.107 1.107 0 010-2.217zm.028-10.493h.02c.173.001 1.102.059 1.149 1.129 0 0 .135 1.288-.348 5.794 0 0-.027.94-.43 1.342 0 0-.483.425-1.018-.136 0 0-.138-.388-.323-1.456l-.294-4.256V11.83s.031-1.075 1.237-1.263h.007zM6.08 2.415V29.58h19.837V8.5h-6.284V2.415zM3.796 0h17.128l5.554 5.44 1.726 1.685V32H3.796z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default ForwardRef;